<template>
  <v-dialog
    :value="value"
    @input="(v) => v || close()"
    hide-overlay
    persistent
    no-click-animation
    transition="fade-transition"
    max-width=" 400px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">発電所情報</span>
        <v-btn small class="btn-close" depressed color="grey lighten-1" v-on:click="close()">
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <table class="kanban">
              <tr>
                <th class="kanban_th">経産省ID</th>
                <td class="kanban_td"><strong>{{info.ministryId}}</strong></td>
              </tr>
              <tr>
                <th class="kanban_th">住所</th>
                <td class="kanban_td"><strong>{{info.address}}</strong></td>
              </tr>
              <tr>
                <th class="kanban_th">DC出力</th>
                <td class="kanban_td"><strong>{{info.dc}}</strong></td>
              </tr>
              
            </table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PfsShowKanbanDialog",
  props: ["value", "info"],
  data() {
    return {
    }
  },
  methods: {
    close() {
        this.$emit("input");
    }
  },
};
</script>
<style lang="scss">

.btn-close {
  position: absolute;
  right: 25px;
  top: 15px;
}
.content {
    padding: 15px;
}
.v-dialog > .v-card > .v-card__text{
  padding-bottom: 0;
}
.kanban {
  height: 100%;
  width:100%;
  border: 1px solid black;
  border-collapse: collapse;
}
.kanban_th {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 5px;
    text-align: center;
    background-color: #BBDEFB;
    width: 40%;
}

.kanban_td {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 5px;
    text-align: center;
}
</style>
